"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";
import { memo } from "react";
import { IndustryLogosProps } from "./types";

const IndustryLogos = ({ logos, className }: IndustryLogosProps) => {
  if (!logos?.length) {
    return null;
  }

  return (
    <section className={cn("section py-6 bg-solitude", className)}>
      <div className="w-full items-center flex">
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-6 md:justify-between md:gap-[min(2.5rem,2.7vw)] lg:flex-nowrap">
            {logos?.map((logo, index) => {
              const logoFields = logo.fields;
              const logoImgFields = logoFields.logoImage?.fields;
              const rawUrl = logoImgFields?.file?.url;
              const imageUrl = rawUrl ? `https:${rawUrl}` : null;

              const justifyClass =
                index === 0
                  ? "justify-start"
                  : index === logos.length - 1
                  ? "justify-end"
                  : "justify-center";

              if (!imageUrl) {
                return (
                  <div
                    key={index}
                    className={cn(
                      "flex justify-center items-center",
                      justifyClass
                    )}
                  >
                    <span className="text-gray-400">No logo</span>
                  </div>
                );
              }
              return (
                <div
                  className={cn("flex items-center object-contain", justifyClass)}
                  key={index}
                >
                  <Image
                    alt={logoFields?.title ?? "Logo icon" as string}
                    src={imageUrl}
                    width={0}
                    height={0}
                    key={index}
                    className={cn(
                      "h-auto w-auto max-w-48 max-h-10 md:max-h-none"
                    )}
                    quality={100}
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(IndustryLogos);
